import { EntityConstants, StringIndexedDict } from "../../../../api/GenericTypes";
import {
  GenericEntityVirtualizedEntitySelectFormFieldProps,
  GenericVirtualizedEntitySelectFormFieldControllerWrapper,
} from "../../../formfields/GenericVirtualizedSelectFormField/GenericVirtualizedEntitySelectFormFieldControllerWrapper";
// import { QuickAddWrapper } from "../../QuickAdd/common/QuickAddWrapper";

import { useContext } from "react";
import { SessionContext } from "../../../contexts/SessionContext";
import { CustomFieldSuggestions } from "../../../../api/CustomFields/CustomFieldsBase";
import {
  customFieldConstants,
  CustomFieldFilters,
  CustomFieldSortingOptionsConsts,
} from "../../../../api/CustomFields/CustomFields";
import { CustomFieldCheckboxSelectForm } from "../../../../Customization/CustomFieldFilters/forms/CustomFieldCheckboxSelectForm";
import { LucideIcon } from "../../../icon/LucideIcon";
import { GenericBooleanStateProvider } from "../../../modals/Modal/GenericModal";
import { Modal } from "../../../../ELN/common/ELNModal/ELNModal";
import { customTypeConstants, CustomTypeFilters } from "../../../../api/CustomTypes/CustomTypes";

export const CustomFieldsVirtualizedSelectForm = <Entity extends StringIndexedDict>(
  props: GenericEntityVirtualizedEntitySelectFormFieldProps<Entity, CustomFieldSuggestions, CustomFieldFilters> & {
    entityConstantsOverride?: EntityConstants;
    entityTypeConstraint?: CustomTypeFilters["entityTypes"];
  }
) => {
  const { session } = useContext(SessionContext);
  return (
    <GenericVirtualizedEntitySelectFormFieldControllerWrapper<Entity, CustomFieldSuggestions, CustomFieldFilters>
      {...props}
      filters={{ sortBy: [{ property: "NAME", sortDirection: "ASC" }], ...props.filters }}
      //   createModal={({ showModal, setShowModal, onCreate }) => (
      //     <QuickAddWrapper showModal={showModal} setShowModal={setShowModal} onCreate={onCreate}>
      //       {(quickAddProps) => <QuickAddDatasetForm {...quickAddProps} />}
      //     </QuickAddWrapper>
      //   )}
      entityConstants={props.entityConstantsOverride ?? customFieldConstants}
      orderByOptions={CustomFieldSortingOptionsConsts}
      allowCreateEntity={session?.permissions.administer_custom_field_schemas && props.allowCreateEntity}
      style={{ ...props.style, gap: 0 }}
      selectFieldStyle={{ ...props.selectFieldStyle, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
      prependChildren={({ value, onChange }) => (
        <GenericBooleanStateProvider>
          {({ isTrue: showModal, setIsTrue: setShowModal }) => (
            <>
              <button
                className="btn btn-default"
                onClick={() => setShowModal(true)}
                title={`Browse ${customTypeConstants.entityPlural}`}
                style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: 0 }}
              >
                <LucideIcon name="folder-search" />
              </button>
              <Modal isOpen={showModal} onClose={setShowModal}>
                <Modal.Title>
                  <h5>Custom Fields</h5>
                </Modal.Title>
                <Modal.Body style={{ height: "50vh", maxHeight: "50vh", width: "90vw", overflowY: "auto" }}>
                  <CustomFieldCheckboxSelectForm
                    value={value}
                    onChange={(value) => {
                      onChange(value);
                      setShowModal(false);
                    }}
                    isMulti={props.isMulti}
                    filters={{
                      ...(props.entityTypeConstraint && { entityTypes: props.entityTypeConstraint }),
                    }}
                  />
                </Modal.Body>
              </Modal>
            </>
          )}
        </GenericBooleanStateProvider>
      )}
    >
      {({ value, onChange }) =>
        props.children ? (
          typeof props.children === "function" ? (
            props.children({ value, onChange })
          ) : (
            <div style={{ marginLeft: 5 }}>{props.children}</div>
          )
        ) : null
      }
    </GenericVirtualizedEntitySelectFormFieldControllerWrapper>
  );
};
